import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { FC } from "react";

export interface IOverviewSection {
    title: string;
    content: string;
    hasDivider?: boolean;
}

export interface IOverviewPanelProps {
    sections: IOverviewSection[];
}

const OverviewPanel: FC<IOverviewPanelProps> = (props) => {
    const { sections } = props;

    return (
        <Paper sx={{ padding: "8px" }}>
            {sections.map((section) => (
                <Box sx={{ margin: "0 0 12px", color: "rgba(0, 0, 0, 0.7)" }}>
                    <Typography fontWeight={700}>{section?.title}</Typography>
                    <Typography
                        fontWeight={400}
                        sx={{ marginTop: "2px" }}
                    >
                        {section.content}
                    </Typography>
                    {section.hasDivider ? <Divider sx={{ margin: "12px 0 0" }} /> : null}
                </Box>
            ))}
        </Paper>
    );
};

OverviewPanel.defaultProps = {
    sections: [],
}

export default OverviewPanel;
